import { render } from "./AdditionalContentAlerts.vue?vue&type=template&id=5b84371e"
import script from "./AdditionalContentAlerts.vue?vue&type=script&lang=js"
export * from "./AdditionalContentAlerts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__